export default __webpack_public_path__ + "static/media/KPI-2.efe2a5d7.webp";